/**
 * HOW A PRODUCT IS ORDERED — BY CART, OR BY ASKING THE SHOP (ask-us products, 2026-10-25).
 *
 * The server states it on every product payload (`orderMode: 'cart' | 'ask'`, the card, the detail and the grid's
 * index alike). A payload that does not say — a legacy row, a cached one, a list that predates the field — is a cart
 * product: the checkout is the authority and refuses an ask line with ORDER_BY_ASKING either way.
 */
export const isAskProduct = (product) => product?.orderMode === 'ask';

/** An ask product with no price above 0 shows no price at all; ₪0 on a giveaway is a promise nobody made. */
export const hidesItsPrice = (product) => isAskProduct(product) && product?.hidePrice === true;
